import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import AllProgramsList from "@/components/dashboard/AllProgramsList";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import {
    Loader2,
    Package,
    CreditCard,
    Plus,
    Wallet,
    History,
    Sparkles
} from "lucide-react";

const MyPrograms = () => {
    const { t } = useLanguage();
    const { user, profile, loading: authLoading } = useAuth();

    if (authLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    }

    if (!user) {
        // Ideally this should redirect or show access denied, 
        // but checks are usually handled by protected route wrappers or useEffects
        return null;
    }

    return (
        <div className="min-h-screen">
            <Navbar />
            <main className="pt-24 pb-12">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col mb-8">
                        <h1 className="text-3xl font-heading font-bold mb-2 flex items-center gap-3">
                            <Package className="h-8 w-8 text-primary" />
                            {t("โปรแกรมของฉัน", "My Programs")}
                        </h1>
                        <p className="text-muted-foreground">
                            {t("จัดการโปรแกรมที่ซื้อ License Key และการใช้งานเครื่อง", "Manage your purchased programs, license keys, and activated machines")}
                        </p>
                    </div>

                    <div className="flex items-center gap-3 flex-wrap mb-8">
                        {/* Credits Display */}
                        <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary/10 border border-primary/20">
                            <CreditCard className="h-5 w-5 text-primary" />
                            <div className="flex items-baseline gap-1">
                                <span className="text-2xl font-bold text-gradient">
                                    {(profile?.credits ?? 0).toLocaleString()}
                                </span>
                                <span className="text-xs text-muted-foreground">{t("เครดิต", "credits")}</span>
                            </div>
                        </div>
                        <Link to="/pricing">
                            <Button variant="outline" className="gap-2">
                                <Plus className="h-4 w-4" />
                                {t("เพิ่มเครดิต", "Add Credits")}
                            </Button>
                        </Link>
                        <Link to="/credit-history">
                            <Button variant="outline" className="gap-2">
                                <Wallet className="h-4 w-4" />
                                {t("ประวัติการเงิน", "Transaction History")}
                            </Button>
                        </Link>
                        <Link to="/history">
                            <Button variant="outline" className="gap-2">
                                <History className="h-4 w-4" />
                                {t("ประวัติการสร้าง", "Generation History")}
                            </Button>
                        </Link>
                        <Link to="/generate">
                            <Button variant="glow" className="gap-2">
                                <Sparkles className="h-4 w-4" />
                                {t("สร้างผลงาน", "Generate")}
                            </Button>
                        </Link>
                    </div>

                    <AllProgramsList />
                </div>
            </main>
        </div>
    );
};

export default MyPrograms;
